import {cookieBanner, type CookieBanner} from "./index";
import type {FunctionImplementation} from "@otto-ec/global-resources/nexus";
import {AppType, appType} from "../helper";

export const resurface = function () {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.onCookieBannerResurface?.()
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onCookieBannerResurface?.postMessage({});
    }
} satisfies FunctionImplementation<CookieBanner["resurface"]>

export const openPreferenceCenter = function (data) {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOpenPreferenceCenter?.(data.error);
        } catch {
            window.o_apps_android?.onOpenPreferenceCenter?.();
        }
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOpenPreferenceCenter?.postMessage(data.error)
    }
} satisfies FunctionImplementation<CookieBanner["openPreferenceCenter"]>

export const optOutAll = function (data) {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOptOutAllVendors?.(data.success, data.error);
        } catch {
            window.o_apps_android?.onOptOutAllVendors?.();
        }
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOptOutAllVendors?.postMessage(data)
    }
} satisfies FunctionImplementation<CookieBanner["optOutAll"]>

export const optOutGeneralVendor = function (data) {
    if (appType() == AppType.ANDROID) {
        try {
            window.o_apps_android?.onOptOutGeneralVendor?.(data.vendorId, data.success, data.error);
        } catch {
            window.o_apps_android?.onOptOutGeneralVendor?.(data.vendorId);
        }

    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.onOptOutGeneralVendor?.postMessage(data);
    }
} satisfies FunctionImplementation<CookieBanner["optOutGeneralVendor"]>

cookieBanner.assignNamespace({resurface, openPreferenceCenter, optOutAll, optOutGeneralVendor})